import { PlusOutlined } from '@ant-design/icons';
import { Button, Card, Col, Form, Input, Row, Select, Table, TablePaginationConfig } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { notifyError } from '../../../store/utils';
import { PagedResultState } from '../../../common/CommonResult';
import queryString from 'query-string';
import { API } from '../../../api';
import dayjs from 'dayjs';
import CustomerSelect from '../../../lib/CustomerSelect';

const TariffList = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const [state, setState] = useState<PagedResultState<any>>({
    loading: true,
    result: {},
  });

  const fetchTariffs = useCallback(async () => {
    setState({
      ...state,
      loading: true,
    });
    try {
      const { result } = await API.get({ apiVersion: 'api' })(
        `/settings/tariff/list${location.search}`
      );
      setState({
        loading: false,
        result,
      });
    } catch (error: any) {
      notifyError(error.message);
    }
  }, [location]);

  useEffect(() => {
    if (location.search) {
      fetchTariffs();
    }
  }, [location.search]);

  useEffect(() => {
    if (!location.search) {
      navigate(`/settings/tariff?page=1&size=10`);
    }
  }, [location]);

  const onFinish = useCallback((values: any) => {
    const search = {
      ...values,
      page: 1,
      size: 10,
    };
    navigate(`/settings/tariff?${queryString.stringify(search)}`);
  }, []);

  const handleTableChange = useCallback(
    (pagination: TablePaginationConfig) => {
      const params = queryString.parse(location.search);
      const search = {
        ...params,
        page: pagination.current || 1,
        size: pagination.pageSize || 10,
      };
      navigate(`/settings/tariff?${queryString.stringify(search)}`);
    },
    [location]
  );

  const columns = [
    {
      title: 'No',
      dataIndex: 'no',
      key: 'no',
    },
    {
      title: 'Тариф нэр',
      key: 'name',
      render: (record: any) => (
        <Link to={`/settings/tariff/update/${record.no}`}>{record.name}</Link>
      ),
    },
    {
      title: 'Төрөл',
      key: 'type',
      render: (record: any) => (record?.customer ? 'Тусгай нөхцөл' : 'Суурь'),
    },
    {
      title: 'Жингийн төрөл',
      key: 'weightType',
      render: (record: any) => 'Үндсэн',
    },
    {
      title: 'Хүргэлт',
      key: 'delivery',
      render: (record: any) => record?.branchArea?.name,
    },
    {
      title: 'Харилцагч нэр',
      key: 'customer',
      render: (record: any) => record?.customer?.name,
    },
    {
      title: 'Хүргэлт',
      key: 'deliveryType',
      render: (record: any) => record?.deliveryType?.code,
    },
    {
      title: 'Бүртгэсэн огноо',
      key: 'createdAt',
      width: 160,
      render: (record: any) => dayjs(record?.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
  ];

  return (
    <Card
      title={`Тарифын жагсаалт`}
      extra={
        <Link to={`/settings/tariff/create`}>
          <Button type="primary" icon={<PlusOutlined />}>
            Тариф нэмэх
          </Button>
        </Link>
      }
    >
      <Form onFinish={onFinish}>
        <Row gutter={[25, 25]}>
          <Col span={4}>
            <Form.Item name="query">
              <Input placeholder="Хайх үг бичнэ үү" />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="customerNo">
              <CustomerSelect showSearch allowClear />
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item name="deliveryType">
              <Select>
                <Select.Option value="">Бүгд</Select.Option>
                <Select.Option value="HOMEDELIVERY">Гараас гарт</Select.Option>
                <Select.Option value="PICKUP">Салбараас авах</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                Хайх
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Table
        size="small"
        bordered
        loading={state.loading}
        dataSource={state.result?.data || []}
        rowKey={'id'}
        pagination={{
          current: state?.result?.page || 1,
          size: 'small',
          pageSize: state?.result?.size || 10,
          total: state?.result?.total,
        }}
        onChange={handleTableChange}
        columns={columns}
      />
    </Card>
  );
};

export default TariffList;
